<template>
<div class="ma-2" style="white-space:break-spaces">
     <v-app dark>
        <toolbar></toolbar>
        <v-row> 
            <!-- :style="`position:absolute; left:${distanceFromLeft}; top:64px; z-index:99`" -->
        <v-btn icon v-if="!showNav" :style="`position:fixed; top:64px; width:0px`" @click="showNav = true"><v-icon large color="blue">arrow forward ios</v-icon></v-btn>
        <v-col style="overflow-y:auto;max-width:300px">
            <v-navigation-drawer :temporary="mobile" :permanent="!mobile" v-model="showNav" style="position:fixed; top:64px; padding-bottom:64px;max-width:256px">                
            <v-list dense nav style="padding-top:0px">
                <v-list-item
                v-for="section in sections"
                :key="section.name"
                link
                style="max-height:40px"
                class="py-1"                
                :to="`/rules/${section.url}`"
                @click="scrollTop"
                >
                <v-list-item-content  v-if="section != 'For Game Masters'">
                    <v-list-item-title>{{ section.name }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-expansion-panels flat v-model="openned">
                        <v-expansion-panel>
                            <!-- @click="goto('forGMs')" -->
                            <v-expansion-panel-header style="padding-left:0; padding-top:6px; padding-bottom:6px; font-size:13px; font-weight:500;" >
                                <v-btn height="30px" elevation="0" color="white" :to="`/rules/forgms`">For Game Masters</v-btn>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content style="padding-right:0px">
                                <v-list dense nav style="padding-left:0; padding-right:0px">
                                    <v-list-item
                                    style="padding-left:0"
                                    v-for="section in gmSections"
                                    :key="section"
                                    :to="`/rules/forgms?section=${section}`"
                                    >
                                        <v-list-item-content>              
                                            <v-list-item-title>{{ section }}</v-list-item-title>
                                        </v-list-item-content>   
                                    </v-list-item>  
                                </v-list>         
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-list-item>
                <v-list-item style="margin-top:12px">
                    <v-list-item-title>In Game Items:</v-list-item-title>
                </v-list-item>
                <v-list-item
                v-for="item in items"
                :key="item"
                link
                :to="`/rules/gameitems?type=${item}`"
                >
                <v-list-item-content>             
                    <v-list-item-title style="margin-left:16px">{{ item }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </v-list>
            </v-navigation-drawer>    
        </v-col>
        <v-col style="padding-left:8px; top:68px; padding-top:84px">
            <router-view></router-view>
        </v-col>
    </v-row>
     </v-app>
    </div>
</template>
<script>
import toolbar from "./toolbar"
import {
  //VBtn,
  VApp,
  VIcon,
  VNavigationDrawer,
  VList,
  VListItem,
  VListItemTitle,
  VListItemContent,
  VCol,
  VRow,
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelHeader,
  VExpansionPanelContent,
  VBtn,
} from "vuetify/lib";


export default {
  name: "App",
  components: {
    VBtn,
    VIcon,
    VApp,
    VNavigationDrawer,
    VList,
    VListItem,
    VListItemTitle,
    VListItemContent,
    VCol,
    VRow,    
    VExpansionPanel,
    VExpansionPanels,
    VExpansionPanelHeader,
    VExpansionPanelContent,     
    toolbar,
  },
  data () {
    return {
        mobile:false,
        showNav:null,
        sections:[
            {name:"Introduction",url:"introduction"},
            {name:"What You need To Know",url:"needtoknow"},
            {name:"Akashic Path Rules",url:"akashicpathsrules"},
            {name:"Using The Website",url:"usingwebsite"},
            {name:"Patch Notes",url:"patchnotes"},
            {name:"Playtest",url:"playtest"},
            {name:"Map Generator",url:"mapgenerator"},
        ],
        currentSection:"Introduction",
        //sections: ["Introduction", "What You need To Know", "Akashic Path Rules", "Using The Website", "Patch Notes", "Playtest", "Map Generator"],
        items: ["Classes", "Races", "Feats", "Perks", "Weapons", "Armor", "Weapon Enchantments", "Armor Enchantments", "Spells", "Maneuvers", "Potions", "Gear", "Wonderous Items"],
        gmSections: ["How to Get Started", "Step By Step", "Character Creation", "Floors, Encounters, Combats", "Journey Selection", "Floors", "Encounters", "Combats", "Character Progression", "Treasure", "Item Prices", "Stores", "Different Style of Play", "General Monster Scaling", "A Final Note", "Alternate Ways to Play"],
        gotoGmSection:"",
        openned:true
      }
    },
    mounted(){
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.mobile = true
        }
        //this.showNav = false
    },
    methods:{        
        goto(){
            console.log(window.location.href)
            if(!window.location.href.includes("forGMs")){
                window.location.href = "/rules/forGMs"
            }
        },
        gmSection(whereTo){
            console.log("wheretogm ", whereTo)
            this.currentSection = "For Game Masters"
            this.gotoGmSection = whereTo
        },
        scrollTop(){
            window.scrollTo({top: 0});
        }
    },
}
</script>
<style>
.v-expansion-panel-content__wrap {
    padding-right:0px !important;
}
</style>